export default __webpack_public_path__ + "static/media/arrows-manager.e10eaf05.svg";